<script setup lang="ts">
interface Props {
   alt: string;
   color?: "white" | "grey" | "default";
}

const props = withDefaults(defineProps<Props>(), {
   color: "default",
});

const animateAttribute = computed(() => {
   return props.color === "grey" ? "fill" : "opacity";
});

const animateValues = computed(() => {
   switch (props.color) {
      case "white":
         return "0.8;0.2;0.8";
      case "grey":
         return "#cbc1c1;#7f7979;#cccccc";
      default:
         return "0.7;1;0.5";
   }
});
</script>

<template>
   <svg
      :class="color"
      class="lds-dna max-w-full"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      style="background: none"
   >
      <title>{{ alt }}</title>
      <circle cx="6.451612903225806" cy="67.5939" r="3.10705">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-0.5s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="0s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-0.5s"
         ></animate>
      </circle>
      <circle cx="6.451612903225806" cy="32.4061" r="2.89295">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.5s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-1s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-0.5s"
         ></animate>
      </circle>
      <circle cx="16.129032258064512" cy="67.3622" r="2.86705">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-0.7s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-0.2s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-0.7s"
         ></animate>
      </circle>
      <circle cx="16.129032258064512" cy="32.6378" r="3.13295">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.7s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.2s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-0.7s"
         ></animate>
      </circle>
      <circle cx="25.806451612903224" cy="61.8177" r="2.62705">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-0.9s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-0.4s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-0.9s"
         ></animate>
      </circle>
      <circle cx="25.806451612903224" cy="38.1823" r="3.37295">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.9s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.4s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-0.9s"
         ></animate>
      </circle>
      <circle cx="35.48387096774193" cy="49.2235" r="2.41295">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.1s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-0.6s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.1s"
         ></animate>
      </circle>
      <circle cx="35.48387096774193" cy="50.7765" r="3.58705">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-2.1s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.6s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.1s"
         ></animate>
      </circle>
      <circle cx="45.16129032258064" cy="37.2315" r="2.65295">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.3s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-0.8s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.3s"
         ></animate>
      </circle>
      <circle cx="45.16129032258064" cy="62.7685" r="3.34705">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-2.3s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.8s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.3s"
         ></animate>
      </circle>
      <circle cx="54.838709677419345" cy="32.4061" r="2.89295">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.5s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-1s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.5s"
         ></animate>
      </circle>
      <circle cx="54.838709677419345" cy="67.5939" r="3.10705">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-2.5s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-2s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.5s"
         ></animate>
      </circle>
      <circle cx="64.51612903225805" cy="32.6378" r="3.13295">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.7s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.2s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.7s"
         ></animate>
      </circle>
      <circle cx="64.51612903225805" cy="67.3622" r="2.86705">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-2.7s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-2.2s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.7s"
         ></animate>
      </circle>
      <circle cx="74.19354838709677" cy="38.1823" r="3.37295">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.9s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.4s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.9s"
         ></animate>
      </circle>
      <circle cx="74.19354838709677" cy="61.8177" r="2.62705">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-2.9s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-2.4s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.9s"
         ></animate>
      </circle>
      <circle cx="83.87096774193547" cy="50.7765" r="3.58705">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-2.1s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.6s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-2.1s"
         ></animate>
      </circle>
      <circle cx="83.87096774193547" cy="49.2235" r="2.41295">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-3.1s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-2.6s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-2.1s"
         ></animate>
      </circle>
      <circle cx="93.54838709677418" cy="62.7685" r="3.34705">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-2.3s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-1.8s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-2.3s"
         ></animate>
      </circle>
      <circle cx="93.54838709677418" cy="37.2315" r="2.65295">
         <animate
            attributeName="r"
            times="0;0.5;1"
            values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
            dur="2s"
            repeatCount="indefinite"
            begin="-3.3s"
         ></animate>
         <animate
            attributeName="cy"
            keyTimes="0;0.5;1"
            values="32;68;32"
            dur="2s"
            repeatCount="indefinite"
            begin="-2.8s"
            keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
            calcMode="spline"
         ></animate>
         <animate
            :attributeName="animateAttribute"
            keyTimes="0;0.5;1"
            :values="animateValues"
            dur="2s"
            repeatCount="indefinite"
            begin="-2.3s"
         ></animate>
      </circle>
   </svg>
</template>

<style scoped lang="scss">
.default circle {
   fill: var(--colour-brand-default); // portal brand colour
}

.white circle {
   fill: #fff;
}
</style>
